export function getChannelIconName(channelSlug: string) {
  const channelIcons = {
    // Indeed
    indeed: 'indeed',
    'indeed-direct': 'indeed',
    indeed_direct: 'indeed',

    // ZipRecruiter
    ziprecruiter: 'ziprecruiter',
    zip_recruiter: 'ziprecruiter',

    // Google
    google: 'google',
    search: 'google',
    performance_max: 'google',

    // Meta
    meta: 'meta',
    outcome_leads: 'meta',

    linkedin: 'linkedin',
    joveo: 'joveo',
    talroo: 'talroo',
    appcast: 'appcast',
    spring: 'spring',
    boost: 'boost',
    reach: 'reach',
    pool: 'pool',
  };

  return channelIcons[channelSlug as keyof typeof channelIcons];
}
